//============================================================================
// Name        : shipments.ts
// Purpose     : Implement shipments and transfers page
// Created     : 2021-04-13
// Author      : Alireza Mohagheghi
// Copyright   : Copyright 2021 Senitron Corporation. All rights reserved.
//============================================================================

import {InitPage} from "../index";

class Shipments {
    init() {
        // start - advanced search
        const advancedSearchDiv = $("#advanced_search");
        advancedSearchDiv.on("click", (e) => {
            if (e.target.classList.value == "collapsed" || e.target.classList.value == "") {
                advancedSearchDiv.addClass("expanded");
            } else {
                advancedSearchDiv.removeClass("expanded");
            }
        });
        // end - advanced search

        const accordionIcon = $(".accordion-arrow-icon");
        accordionIcon.on("click", (e) => {
            if (e.target.classList.contains("fa-chevron-down")) {
                e.target.classList.remove("fa-chevron-down");
                e.target.classList.add("fa-chevron-up");
            } else {
                e.target.classList.add("fa-chevron-down");
                e.target.classList.remove("fa-chevron-up");
            }
        });
    }
}

export function LoadPage() {
    InitPage("shipments", () => {
        const shipments = new Shipments();
        shipments.init();
    });
    InitPage("cdm_handhelds", () => {
        const cdm_handhelds = new Shipments();
        cdm_handhelds.init();
    });
    InitPage("prices edit", () => {
        const billing_options = new Shipments();
        billing_options.init();
    });
}
